var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-attribute-container" },
    [
      _c("div", { staticClass: "attribute-card" }, [
        !_vm.hasAttributes
          ? _c("div", { staticClass: "no-attributes" }, [
              _c("p", [_vm._v(_vm._s(_vm.noAttributesMessage))]),
            ])
          : _c(
              "div",
              { staticClass: "attributes-content" },
              [
                _vm._l(_vm.currentAttributeList, function (attribute, key) {
                  return _c("div", { key: key, staticClass: "attribute-row" }, [
                    _c("div", { staticClass: "attribute-icon" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(
                          _vm._s(_vm.getAttributeIcon(key, attribute.type))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "attribute-details" }, [
                      _c("div", { staticClass: "attribute-name" }, [
                        _vm._v(_vm._s(_vm.getAttributeLabel(key))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.formatAttributeValue(
                                  attribute,
                                  key
                                ),
                              },
                              expression:
                                "{ content: formatAttributeValue(attribute, key) }",
                            },
                          ],
                          staticClass: "attribute-value",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.formatAttributeValue(attribute, key)) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "attribute-actions" }, [
                      _vm.isAttributeEditable(key)
                        ? _c(
                            "button",
                            {
                              staticClass: "action-button edit-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.editAttribute(key, attribute)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "action-button copy-btn",
                          on: {
                            click: function ($event) {
                              return _vm.copyAttribute(key, attribute)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("content_copy"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isAttributeDeletable(key)
                        ? _c(
                            "button",
                            {
                              staticClass: "action-button delete-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.confirmDeleteAttribute(key)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm.metaReferralsBtn &&
                _vm.visitor &&
                _vm.visitor.metaReferrals &&
                _vm.visitor.metaReferrals.length > 0
                  ? _c("div", { staticClass: "meta-referrals-section" }, [
                      _c(
                        "div",
                        {
                          staticClass: "meta-referrals-button",
                          on: {
                            click: function ($event) {
                              _vm.modaladvertisingdetail = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("ads_click"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("İlgili Reklamlar")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
      ]),
      _vm._v(" "),
      _vm.editModal
        ? _c("div", { staticClass: "va-modal-overlay" }, [
            _c("div", { staticClass: "va-modal" }, [
              _c("div", { staticClass: "va-modal-header" }, [
                _c("div", { staticClass: "va-modal-title" }, [
                  _vm._v(_vm._s(_vm.editModalTitle)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "va-modal-close",
                    on: { click: _vm.closeEditModal },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "va-modal-body" }, [
                _c(
                  "div",
                  { staticClass: "edit-attribute-form" },
                  [
                    _vm.editingAttribute.type === "boolean"
                      ? [
                          _c("a-switch", {
                            model: {
                              value: _vm.editingAttributeValue,
                              callback: function ($$v) {
                                _vm.editingAttributeValue = $$v
                              },
                              expression: "editingAttributeValue",
                            },
                          }),
                        ]
                      : _vm.editingAttribute.type === "date"
                      ? [
                          _c("a-date-picker", {
                            style: { width: "100%" },
                            attrs: {
                              format: _vm.dateFormat,
                              placeholder: _vm.$t("message.selectDate"),
                              "show-today": true,
                              "allow-clear": true,
                            },
                            on: { change: _vm.handleDateChange },
                            model: {
                              value: _vm.editingAttributeValue,
                              callback: function ($$v) {
                                _vm.editingAttributeValue = $$v
                              },
                              expression: "editingAttributeValue",
                            },
                          }),
                        ]
                      : _vm.editingAttribute.type === "dropdown"
                      ? [
                          _c(
                            "a-select",
                            {
                              style: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("message.selectOption"),
                                "allow-clear": true,
                              },
                              model: {
                                value: _vm.editingAttributeValue,
                                callback: function ($$v) {
                                  _vm.editingAttributeValue = $$v
                                },
                                expression: "editingAttributeValue",
                              },
                            },
                            _vm._l(
                              _vm.editingAttribute.options,
                              function (option) {
                                return _c(
                                  "a-select-option",
                                  { key: option, attrs: { value: option } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.formatDropdownOption(
                                            option,
                                            _vm.editingAttributeKey
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ]
                      : _vm.editingAttribute.type === "json"
                      ? [
                          _c("prism-editor", {
                            staticClass: "json-editor",
                            attrs: { highlight: _vm.highlighter },
                            model: {
                              value: _vm.editingAttributeValue,
                              callback: function ($$v) {
                                _vm.editingAttributeValue = $$v
                              },
                              expression: "editingAttributeValue",
                            },
                          }),
                        ]
                      : [
                          (_vm.editingAttribute.type === "number"
                            ? "number"
                            : "text") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editingAttributeValue,
                                    expression: "editingAttributeValue",
                                  },
                                ],
                                staticClass: "edit-input",
                                attrs: {
                                  placeholder: _vm.$t("message.enterNewValue"),
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.editingAttributeValue
                                  )
                                    ? _vm._i(_vm.editingAttributeValue, null) >
                                      -1
                                    : _vm.editingAttributeValue,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.editingAttributeValue,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.editingAttributeValue =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.editingAttributeValue = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.editingAttributeValue = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.editingAttribute.type === "number"
                                ? "number"
                                : "text") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editingAttributeValue,
                                    expression: "editingAttributeValue",
                                  },
                                ],
                                staticClass: "edit-input",
                                attrs: {
                                  placeholder: _vm.$t("message.enterNewValue"),
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.editingAttributeValue,
                                    null
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.editingAttributeValue = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editingAttributeValue,
                                    expression: "editingAttributeValue",
                                  },
                                ],
                                staticClass: "edit-input",
                                attrs: {
                                  placeholder: _vm.$t("message.enterNewValue"),
                                  type:
                                    _vm.editingAttribute.type === "number"
                                      ? "number"
                                      : "text",
                                },
                                domProps: { value: _vm.editingAttributeValue },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.editingAttributeValue =
                                      $event.target.value
                                  },
                                },
                              }),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "form-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "cancel-btn",
                          on: { click: _vm.closeEditModal },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "save-btn",
                          on: { click: _vm.saveAttributeEdit },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.update")))]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.addModal
        ? _c("div", { staticClass: "va-modal-overlay" }, [
            _c("div", { staticClass: "va-modal" }, [
              _c("div", { staticClass: "va-modal-header" }, [
                _c("div", { staticClass: "va-modal-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("settings.newVisitorProfileInformation"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "va-modal-close",
                    on: {
                      click: function ($event) {
                        _vm.addModal = false
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "va-modal-description" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("settings.newVisitorProfileInformationDescription")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "va-modal-body" },
                [
                  _c("VisitorAttributesForm", {
                    on: {
                      input: function (data) {
                        return (_vm.form = data)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "va-modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "cancel-btn",
                    on: {
                      click: function ($event) {
                        _vm.addModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "save-btn",
                    on: {
                      click: function ($event) {
                        return _vm.createVisitorAttribute()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("settings.create")))]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteModal
        ? _c("div", { staticClass: "va-modal-overlay" }, [
            _c("div", { staticClass: "va-modal" }, [
              _c("div", { staticClass: "va-modal-header" }, [
                _c("div", { staticClass: "va-modal-title" }, [
                  _vm._v("Silme Onayı"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "va-modal-close",
                    on: { click: _vm.closeDeleteModal },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "va-modal-body" }, [
                _c("div", { staticClass: "delete-confirm" }, [
                  _c("p", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.getAttributeLabel(_vm.deleteAttributeKey))
                      ),
                    ]),
                    _vm._v(" alanını silmek istediğinizden emin misiniz?"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "cancel-btn",
                        on: { click: _vm.closeDeleteModal },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "delete-confirm-btn",
                        on: { click: _vm.deleteAttribute },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.delete")))]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.canAddAttribute
        ? _c(
            "a-tooltip",
            { attrs: { placement: "topLeft" } },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v("Yeni Öznitelik Ekle")]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "add-attribute-button",
                  on: { click: _vm.openAddModal },
                },
                [_c("span", { staticClass: "material-icons" }, [_vm._v("add")])]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modaladvertisingdetail
        ? _c("VisitorMetaReferralsModal", {
            attrs: {
              metaReferrals: _vm.visitor.metaReferrals,
              modaladvertisingdetail: _vm.modaladvertisingdetail,
            },
            on: {
              close: function ($event) {
                _vm.modaladvertisingdetail = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }